/**
 * Color constants using Flat UI Colors
 * https://flatuicolors.com/palette/defo
 */

export interface ColorPalette {
  GREEN: string;
  YELLOW: string;
  RED: string;
  BLUE: string;
  WHITE: string;
  BLACK: string;
  GRAY: string;
  ORANGE: string;
  PURPLE: string;
  BODY_BG: string;
  SILVER: string;
}

export const COLORS: ColorPalette = {
  // Flat UI Colors
  GREEN: '#2ecc71',   // Emerald
  YELLOW: '#f1c40f',  // Sun Flower
  RED: '#e74c3c',     // Alizarin
  BLUE: '#3498db',    // Peter River
  WHITE: '#ecf0f1',   // Clouds
  BLACK: '#2c3e50',   // Midnight Blue
  GRAY: '#95a5a6',    // Concrete
  ORANGE: '#e67e22',  // Carrot
  PURPLE: '#9b59b6',  // Amethyst
  BODY_BG: '#34495e', // Wet Asphalt
  SILVER: '#bdc3c7'   // Silver
};

export default COLORS;
